export const COPY = {
  forgotPassword: 'Forgotten password?',
  continue: 'Continue',
  invalidCredentials: 'Invalid username or password'
}
